module.exports = __webpack_public_path__ + "static/img/ewx.8c1b9154.png";